<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'vaccine',
};
</script>

<style>
</style>
